// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Management - Main Container */
/* WHAT: Scoped styles for the UserManagement component.
   WHY:  All classes prefixed with um- to avoid collisions with AzureADGroups.css
         and other component styles. Follows the same design language. */

.um-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  background: #f5f7fa;
  min-height: 100vh;
}

/* Page Header */
.um-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.um-page-header h1 {
  margin: 0;
  font-size: 26px;
  color: #1a202c;
  font-weight: 600;
}

.um-page-header h1 i {
  margin-right: 10px;
  color: #3182ce;
}

.um-header-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #718096;
}

.um-header-right {
  display: flex;
  gap: 12px;
}

/* Filters */
.um-filters {
  background: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  display: flex;
  gap: 20px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.um-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.um-filter-group label {
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
}

.um-filter-group input[type="text"] {
  padding: 8px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  min-width: 250px;
  transition: border-color 0.2s ease;
}

.um-filter-group input[type="text"]:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.um-filter-group select {
  padding: 8px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  min-width: 180px;
  cursor: pointer;
}

.um-filter-group select:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.um-checkbox-filter {
  flex-direction: row !important;
  align-items: center !important;
  margin-top: 0;
}

.um-checkbox-filter input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  cursor: pointer;
}

.um-user-count {
  font-size: 14px;
  color: #718096;
  font-weight: 500;
  padding: 8px 0;
}

/* Table */
.um-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.um-table {
  width: 100%;
  border-collapse: collapse;
}

.um-table thead {
  background: #edf2f7;
}

.um-table th {
  padding: 14px 16px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #cbd5e0;
}

.um-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.15s ease;
}

.um-table tbody tr:hover {
  background: #f7fafc;
}

.um-table tbody tr.um-inactive-row {
  opacity: 0.55;
  background: #fafafa;
}

.um-table td {
  padding: 12px 16px;
  font-size: 14px;
  color: #4a5568;
}

.um-email-cell {
  font-size: 13px;
  color: #718096;
}

.um-date-cell {
  font-size: 13px;
  color: #718096;
  white-space: nowrap;
}

/* Role Badges */
.um-role-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  background: #e2e8f0;
  color: #4a5568;
}

.um-role-badge.um-dev-admin {
  background: #feebc8;
  color: #7c2d12;
}

.um-role-badge.um-uar-admin {
  background: #bee3f8;
  color: #2c5282;
}

.um-role-badge.um-attester {
  background: #e9d8fd;
  color: #44337a;
}

.um-role-badge.um-dba {
  background: #c6f6d5;
  color: #22543d;
}

/* Action Buttons */
.um-action-buttons {
  display: flex;
  gap: 6px;
}

.um-btn-icon {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: #edf2f7;
  color: #4a5568;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-size: 13px;
}

.um-btn-icon:hover {
  background: #e2e8f0;
  color: #2d3748;
  transform: translateY(-1px);
}

.um-btn-icon-danger {
  color: #e53e3e;
}

.um-btn-icon-danger:hover {
  background: #fed7d7;
  color: #c53030;
}

.um-btn-icon-success {
  color: #38a169;
}

.um-btn-icon-success:hover {
  background: #c6f6d5;
  color: #276749;
}

.um-btn-icon-azure {
  color: #3182ce;
}

.um-btn-icon-azure:hover {
  background: #bee3f8;
  color: #2c5282;
}

.um-btn-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.um-btn-link {
  background: none;
  border: none;
  color: #3182ce;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  text-decoration: none;
}

.um-btn-link:hover {
  text-decoration: underline;
  color: #2c5282;
}

/* Modals */
.um-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  animation: umFadeIn 0.2s ease;
}

@keyframes umFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.um-modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: umSlideUp 0.3s ease;
}

@keyframes umSlideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.um-modal-small {
  max-width: 480px;
}

.um-modal-wide {
  max-width: 900px;
}

.um-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.um-modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #1a202c;
  font-weight: 600;
}

.um-modal-header h2 i {
  margin-right: 8px;
  color: #3182ce;
}

.um-modal-header-danger h2 i {
  color: #e53e3e;
}

.um-modal-close {
  background: none;
  border: none;
  font-size: 22px;
  color: #a0aec0;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.um-modal-close:hover {
  background: #f7fafc;
  color: #4a5568;
}

.um-modal-body {
  padding: 24px;
}

.um-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Forms */
.um-form-group {
  margin-bottom: 18px;
}

.um-form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  margin-bottom: 6px;
}

.um-form-group input[type="text"],
.um-form-group select,
.um-form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.um-form-group input:focus,
.um-form-group select:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.um-form-row {
  display: flex;
  gap: 16px;
}

.um-form-row .um-form-group {
  flex: 1 1;
}

.um-readonly {
  background: #edf2f7 !important;
  cursor: not-allowed !important;
}

/* Enterprise search results */
.um-search-results {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 6px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}

.um-search-result-item {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.15s ease;
}

.um-search-result-item:hover {
  background: #f7fafc;
}

.um-search-result-item:last-child {
  border-bottom: none;
}

.um-search-result-item.um-already-provisioned {
  opacity: 0.5;
  cursor: not-allowed;
}

.um-search-result-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.um-search-result-main strong {
  font-size: 14px;
  color: #1a202c;
}

.um-search-result-email {
  font-size: 13px;
  color: #718096;
}

.um-search-result-meta {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #a0aec0;
}

.um-already-badge {
  background: #fed7d7;
  color: #742a2a;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.um-disabled-badge {
  background: #feebc8;
  color: #7c2d12;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.um-selected-enterprise {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #ebf8ff;
  border: 1px solid #bee3f8;
  border-radius: 6px;
  font-size: 14px;
  color: #2c5282;
}

.um-selected-enterprise i {
  color: #38a169;
}

.um-selected-enterprise span {
  flex: 1 1;
}

.um-selected-enterprise button {
  background: none;
  border: none;
  color: #a0aec0;
  cursor: pointer;
  font-size: 14px;
  padding: 2px;
}

.um-selected-enterprise button:hover {
  color: #e53e3e;
}

/* Delete modal */
.um-delete-highlight {
  font-size: 18px;
  text-align: center;
  margin: 16px 0;
  color: #1a202c;
}

.um-warning-text {
  background: #fef5e7;
  padding: 12px;
  border-radius: 6px;
  border-left: 3px solid #f6ad55;
  font-size: 14px;
  color: #744210;
}

.um-warning-box {
  background: #fef5e7;
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #f6ad55;
  font-size: 14px;
  color: #744210;
}

/* Groups section inside modal */
.um-groups-section {
  margin-bottom: 24px;
}

.um-groups-section h3 {
  font-size: 16px;
  color: #2d3748;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.um-groups-table {
  width: 100%;
  border-collapse: collapse;
}

.um-groups-table thead {
  background: #f7fafc;
}

.um-groups-table th {
  padding: 10px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 2px solid #e2e8f0;
}

.um-groups-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
}

.um-groups-table tbody tr:hover {
  background: #f7fafc;
}

.um-groups-table td {
  padding: 10px 12px;
  font-size: 14px;
  color: #4a5568;
}

.um-group-desc {
  font-size: 12px;
  color: #a0aec0;
  margin-top: 2px;
}

.um-muted {
  color: #a0aec0;
  font-size: 14px;
  font-style: italic;
}

/* Push to Azure results */
.um-push-results {
  margin-bottom: 20px;
  padding: 16px;
  background: #ebf8ff;
  border-radius: 8px;
  border-left: 4px solid #3182ce;
}

.um-push-results h4 {
  margin: 0 0 10px 0;
  font-size: 15px;
  color: #2c5282;
}

.um-push-results h4 i {
  margin-right: 6px;
}

.um-push-stats {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.um-push-stat {
  font-size: 14px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
}

.um-stat-added {
  background: #c6f6d5;
  color: #22543d;
}

.um-stat-removed {
  background: #fed7d7;
  color: #742a2a;
}

.um-stat-unchanged {
  background: #e2e8f0;
  color: #4a5568;
}

.um-push-errors {
  margin-top: 10px;
}

.um-push-error {
  font-size: 13px;
  color: #e53e3e;
  padding: 4px 0;
}

.um-push-error i {
  margin-right: 4px;
}

/* Alerts */
.um-container .alert {
  padding: 14px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  animation: umSlideDown 0.3s ease;
}

@keyframes umSlideDown {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.um-container .alert-success {
  background: #c6f6d5;
  color: #22543d;
  border-left: 4px solid #38a169;
}

.um-container .alert-error {
  background: #fed7d7;
  color: #742a2a;
  border-left: 4px solid #e53e3e;
}

.um-alert-dismiss {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  padding: 0 4px;
}

.um-alert-dismiss:hover {
  opacity: 1;
}

/* Loading */
.um-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.um-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid #e2e8f0;
  border-top-color: #3182ce;
  border-radius: 50%;
  animation: umSpin 0.8s linear infinite;
}

@keyframes umSpin {
  to { transform: rotate(360deg); }
}

.um-loading p {
  margin-top: 14px;
  font-size: 15px;
  color: #718096;
}

/* Empty state */
.um-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #a0aec0;
}

.um-empty-state i {
  font-size: 48px;
  margin-bottom: 12px;
  display: block;
}

.um-empty-state p {
  font-size: 15px;
  color: #718096;
}

/* Responsive */
@media (max-width: 1200px) {
  .um-table th, .um-table td {
    padding: 10px 12px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .um-container {
    padding: 16px;
  }

  .um-page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .um-filters {
    flex-direction: column;
    align-items: stretch;
  }

  .um-filter-group input[type="text"],
  .um-filter-group select {
    width: 100%;
    min-width: auto;
  }

  .um-table-container {
    overflow-x: auto;
  }

  .um-table {
    min-width: 800px;
  }

  .um-modal-content {
    width: 95%;
    margin: 10px;
  }

  .um-form-row {
    flex-direction: column;
    gap: 0;
  }
}

/* Focus visible for accessibility */
.um-container button:focus-visible,
.um-container input:focus-visible,
.um-container select:focus-visible {
  outline: 2px solid #3182ce;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserManagement.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;;wEAEwE;;AAExE;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;AACF;;AAEA,oCAAoC;AACpC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* User Management - Main Container */\n/* WHAT: Scoped styles for the UserManagement component.\n   WHY:  All classes prefixed with um- to avoid collisions with AzureADGroups.css\n         and other component styles. Follows the same design language. */\n\n.um-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #f5f7fa;\n  min-height: 100vh;\n}\n\n/* Page Header */\n.um-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.um-page-header h1 {\n  margin: 0;\n  font-size: 26px;\n  color: #1a202c;\n  font-weight: 600;\n}\n\n.um-page-header h1 i {\n  margin-right: 10px;\n  color: #3182ce;\n}\n\n.um-header-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: #718096;\n}\n\n.um-header-right {\n  display: flex;\n  gap: 12px;\n}\n\n/* Filters */\n.um-filters {\n  background: white;\n  padding: 16px 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 24px;\n  display: flex;\n  gap: 20px;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.um-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.um-filter-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.um-filter-group input[type=\"text\"] {\n  padding: 8px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 250px;\n  transition: border-color 0.2s ease;\n}\n\n.um-filter-group input[type=\"text\"]:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n}\n\n.um-filter-group select {\n  padding: 8px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 180px;\n  cursor: pointer;\n}\n\n.um-filter-group select:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n}\n\n.um-checkbox-filter {\n  flex-direction: row !important;\n  align-items: center !important;\n  margin-top: 0;\n}\n\n.um-checkbox-filter input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n  cursor: pointer;\n}\n\n.um-user-count {\n  font-size: 14px;\n  color: #718096;\n  font-weight: 500;\n  padding: 8px 0;\n}\n\n/* Table */\n.um-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.um-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.um-table thead {\n  background: #edf2f7;\n}\n\n.um-table th {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2d3748;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #cbd5e0;\n}\n\n.um-table tbody tr {\n  border-bottom: 1px solid #e2e8f0;\n  transition: background-color 0.15s ease;\n}\n\n.um-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.um-table tbody tr.um-inactive-row {\n  opacity: 0.55;\n  background: #fafafa;\n}\n\n.um-table td {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.um-email-cell {\n  font-size: 13px;\n  color: #718096;\n}\n\n.um-date-cell {\n  font-size: 13px;\n  color: #718096;\n  white-space: nowrap;\n}\n\n/* Role Badges */\n.um-role-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.um-role-badge.um-dev-admin {\n  background: #feebc8;\n  color: #7c2d12;\n}\n\n.um-role-badge.um-uar-admin {\n  background: #bee3f8;\n  color: #2c5282;\n}\n\n.um-role-badge.um-attester {\n  background: #e9d8fd;\n  color: #44337a;\n}\n\n.um-role-badge.um-dba {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n/* Action Buttons */\n.um-action-buttons {\n  display: flex;\n  gap: 6px;\n}\n\n.um-btn-icon {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  background: #edf2f7;\n  color: #4a5568;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  font-size: 13px;\n}\n\n.um-btn-icon:hover {\n  background: #e2e8f0;\n  color: #2d3748;\n  transform: translateY(-1px);\n}\n\n.um-btn-icon-danger {\n  color: #e53e3e;\n}\n\n.um-btn-icon-danger:hover {\n  background: #fed7d7;\n  color: #c53030;\n}\n\n.um-btn-icon-success {\n  color: #38a169;\n}\n\n.um-btn-icon-success:hover {\n  background: #c6f6d5;\n  color: #276749;\n}\n\n.um-btn-icon-azure {\n  color: #3182ce;\n}\n\n.um-btn-icon-azure:hover {\n  background: #bee3f8;\n  color: #2c5282;\n}\n\n.um-btn-icon:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.um-btn-link {\n  background: none;\n  border: none;\n  color: #3182ce;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  text-decoration: none;\n}\n\n.um-btn-link:hover {\n  text-decoration: underline;\n  color: #2c5282;\n}\n\n/* Modals */\n.um-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n  animation: umFadeIn 0.2s ease;\n}\n\n@keyframes umFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.um-modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: umSlideUp 0.3s ease;\n}\n\n@keyframes umSlideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.um-modal-small {\n  max-width: 480px;\n}\n\n.um-modal-wide {\n  max-width: 900px;\n}\n\n.um-modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.um-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #1a202c;\n  font-weight: 600;\n}\n\n.um-modal-header h2 i {\n  margin-right: 8px;\n  color: #3182ce;\n}\n\n.um-modal-header-danger h2 i {\n  color: #e53e3e;\n}\n\n.um-modal-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.um-modal-close:hover {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.um-modal-body {\n  padding: 24px;\n}\n\n.um-modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* Forms */\n.um-form-group {\n  margin-bottom: 18px;\n}\n\n.um-form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n  margin-bottom: 6px;\n}\n\n.um-form-group input[type=\"text\"],\n.um-form-group select,\n.um-form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.um-form-group input:focus,\n.um-form-group select:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n}\n\n.um-form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.um-form-row .um-form-group {\n  flex: 1;\n}\n\n.um-readonly {\n  background: #edf2f7 !important;\n  cursor: not-allowed !important;\n}\n\n/* Enterprise search results */\n.um-search-results {\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  max-height: 200px;\n  overflow-y: auto;\n  margin-top: 6px;\n  background: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);\n}\n\n.um-search-result-item {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.um-search-result-item:hover {\n  background: #f7fafc;\n}\n\n.um-search-result-item:last-child {\n  border-bottom: none;\n}\n\n.um-search-result-item.um-already-provisioned {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.um-search-result-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.um-search-result-main strong {\n  font-size: 14px;\n  color: #1a202c;\n}\n\n.um-search-result-email {\n  font-size: 13px;\n  color: #718096;\n}\n\n.um-search-result-meta {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #a0aec0;\n}\n\n.um-already-badge {\n  background: #fed7d7;\n  color: #742a2a;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.um-disabled-badge {\n  background: #feebc8;\n  color: #7c2d12;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.um-selected-enterprise {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #ebf8ff;\n  border: 1px solid #bee3f8;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #2c5282;\n}\n\n.um-selected-enterprise i {\n  color: #38a169;\n}\n\n.um-selected-enterprise span {\n  flex: 1;\n}\n\n.um-selected-enterprise button {\n  background: none;\n  border: none;\n  color: #a0aec0;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 2px;\n}\n\n.um-selected-enterprise button:hover {\n  color: #e53e3e;\n}\n\n/* Delete modal */\n.um-delete-highlight {\n  font-size: 18px;\n  text-align: center;\n  margin: 16px 0;\n  color: #1a202c;\n}\n\n.um-warning-text {\n  background: #fef5e7;\n  padding: 12px;\n  border-radius: 6px;\n  border-left: 3px solid #f6ad55;\n  font-size: 14px;\n  color: #744210;\n}\n\n.um-warning-box {\n  background: #fef5e7;\n  padding: 16px;\n  border-radius: 8px;\n  border-left: 4px solid #f6ad55;\n  font-size: 14px;\n  color: #744210;\n}\n\n/* Groups section inside modal */\n.um-groups-section {\n  margin-bottom: 24px;\n}\n\n.um-groups-section h3 {\n  font-size: 16px;\n  color: #2d3748;\n  margin: 0 0 12px 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.um-groups-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.um-groups-table thead {\n  background: #f7fafc;\n}\n\n.um-groups-table th {\n  padding: 10px 12px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #4a5568;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.um-groups-table tbody tr {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.um-groups-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.um-groups-table td {\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.um-group-desc {\n  font-size: 12px;\n  color: #a0aec0;\n  margin-top: 2px;\n}\n\n.um-muted {\n  color: #a0aec0;\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Push to Azure results */\n.um-push-results {\n  margin-bottom: 20px;\n  padding: 16px;\n  background: #ebf8ff;\n  border-radius: 8px;\n  border-left: 4px solid #3182ce;\n}\n\n.um-push-results h4 {\n  margin: 0 0 10px 0;\n  font-size: 15px;\n  color: #2c5282;\n}\n\n.um-push-results h4 i {\n  margin-right: 6px;\n}\n\n.um-push-stats {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.um-push-stat {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 6px;\n}\n\n.um-stat-added {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.um-stat-removed {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n.um-stat-unchanged {\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.um-push-errors {\n  margin-top: 10px;\n}\n\n.um-push-error {\n  font-size: 13px;\n  color: #e53e3e;\n  padding: 4px 0;\n}\n\n.um-push-error i {\n  margin-right: 4px;\n}\n\n/* Alerts */\n.um-container .alert {\n  padding: 14px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  animation: umSlideDown 0.3s ease;\n}\n\n@keyframes umSlideDown {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.um-container .alert-success {\n  background: #c6f6d5;\n  color: #22543d;\n  border-left: 4px solid #38a169;\n}\n\n.um-container .alert-error {\n  background: #fed7d7;\n  color: #742a2a;\n  border-left: 4px solid #e53e3e;\n}\n\n.um-alert-dismiss {\n  margin-left: auto;\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n  padding: 0 4px;\n}\n\n.um-alert-dismiss:hover {\n  opacity: 1;\n}\n\n/* Loading */\n.um-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.um-spinner {\n  width: 44px;\n  height: 44px;\n  border: 4px solid #e2e8f0;\n  border-top-color: #3182ce;\n  border-radius: 50%;\n  animation: umSpin 0.8s linear infinite;\n}\n\n@keyframes umSpin {\n  to { transform: rotate(360deg); }\n}\n\n.um-loading p {\n  margin-top: 14px;\n  font-size: 15px;\n  color: #718096;\n}\n\n/* Empty state */\n.um-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #a0aec0;\n}\n\n.um-empty-state i {\n  font-size: 48px;\n  margin-bottom: 12px;\n  display: block;\n}\n\n.um-empty-state p {\n  font-size: 15px;\n  color: #718096;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .um-table th, .um-table td {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .um-container {\n    padding: 16px;\n  }\n\n  .um-page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .um-filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .um-filter-group input[type=\"text\"],\n  .um-filter-group select {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .um-table-container {\n    overflow-x: auto;\n  }\n\n  .um-table {\n    min-width: 800px;\n  }\n\n  .um-modal-content {\n    width: 95%;\n    margin: 10px;\n  }\n\n  .um-form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n}\n\n/* Focus visible for accessibility */\n.um-container button:focus-visible,\n.um-container input:focus-visible,\n.um-container select:focus-visible {\n  outline: 2px solid #3182ce;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
